import { useEffect, useState } from "react";
import InstallPWAButton from "../components/InstallPWAButton";

export default function Home({ logo, name, setName, room, setRoom, joinRoom }) {
  const [tutorialStep, setTutorialStep] = useState(0);

  useEffect(() => {
    try {
      const tutorialDone = localStorage.getItem("tutorialDone") === "true";
      if (tutorialDone) {
        setTutorialStep(0);
        return;
      }

      const hasName = !!String(name || "").trim();
      const hasRoom = !!String(room || "").trim();

      if (hasRoom) {
        if (!hasName) setTutorialStep(1);
        else setTutorialStep(3);
        return;
      }

      if (!hasName) {
        setTutorialStep(1);
        return;
      }

      if (!hasRoom) {
        setTutorialStep(2);
        return;
      }

      setTutorialStep(3);
    } catch {
      setTutorialStep(1);
    }
  }, [name, room]);

  const handleJoin = () => {
    try {
      const hasPrefilledRoom = !!String(room || "").trim();

      if (hasPrefilledRoom) {
        localStorage.setItem("tutorialDone", "true");
        localStorage.removeItem("tutorialStep");
      } else {
        localStorage.setItem("tutorialStep", "4");
      }
    } catch {
      // ignore storage issues
    }

    joinRoom();
  };

  return (
    <div className="wp-page">
      <img src={logo} alt="Watch Party Rooms" className="floatingLogo" />

      <div className="homeTaglineRow">
        <div className="homeTagline">How links bring us together 🔗</div>
       </div>

      <div style={{ display: "flex", justifyContent: "center", marginTop: 12 }}>
        <InstallPWAButton />
      </div>

      <div className="card card-pad homeCard" style={{ maxWidth: 520 }}>
        <div
          className="stack"
          style={{ width: "100%", alignItems: "stretch" }}
        >
          <div
            className={`tutorial-ring ${tutorialStep === 1 ? "is-active" : ""}`}
            style={{
              display: "block",
              width: "100%",
              minWidth: 0,
              alignSelf: "stretch",
            }}
          >
            <input
              className="input"
              style={{
                display: "block",
                width: "100%",
                boxSizing: "border-box",
              }}
              placeholder="Your name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div
            className={`tutorial-ring ${tutorialStep === 2 ? "is-active" : ""}`}
            style={{
              display: "block",
              width: "100%",
              minWidth: 0,
              alignSelf: "stretch",
            }}
          >
            <input
              className="input"
              style={{
                display: "block",
                width: "100%",
                boxSizing: "border-box",
              }}
              placeholder="Room name"
              value={room}
              onChange={(e) => setRoom(e.target.value)}
            />
          </div>

          <div className="controls-row">
            <div
              className={`tutorial-ring tutorial-ring-inline ${
                tutorialStep === 3 ? "is-active" : ""
              }`}
            >
              <button className="btn btn-primary" onClick={handleJoin}>
                Join Room
              </button>
            </div>
          </div>

          <div className="mini">
            Set your name → Name your room → Join room
          </div>
        </div>
      </div>
    </div>
  );
}